import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BookingsRoutingModule } from './bookings-routing.module';
import { BookingsComponent } from './bookings.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MaterialModule } from '../../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BookingOverviewComponent, ImageDialogComponent } from './booking-overview/booking-overview.component';


@NgModule({
  declarations: [
    BookingsComponent,
    BookingOverviewComponent,
    ImageDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    BookingsRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMatSelectSearchModule
  ],
  schemas:[NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA]
})
export class BookingsModule { }
